import { useCallback } from "react";

import { trpc } from "@/common/helpers/trpc";
import type { FormType } from "@/features/LiveFormEditor/common/LiveFormEditorContext";

type UseInvalidateEditedFormQueryArgs = {
  formType: FormType;
  formId: string;
};

export const useInvalidateEditedFormQuery = ({ formType, formId }: UseInvalidateEditedFormQueryArgs) => {
  const utils = trpc.useUtils();

  return useCallback(async () => {
    const withoutRefetchingMountedQueries = { refetchType: "none" } as const;

    await Promise.all([
      utils.getCampaignListPagedTableData.invalidate(),
      utils.getCampaignHubPageData.invalidate({ formId }),
      ...(formType === "ticketing"
        ? [utils.getTicketing.invalidate({ ticketingId: formId }, withoutRefetchingMountedQueries)]
        : [
            utils.getDonationFormWithUserOrOrgAccess.invalidate(
              { donationFormId: formId },
              withoutRefetchingMountedQueries
            ),
            utils.getDonationFormWithFundraiserAccess.invalidate(
              { donationFormId: formId },
              withoutRefetchingMountedQueries
            ),
          ]),
    ]);
  }, [formType, formId, utils]);
};
